import { RiBookMarkLine } from "react-icons/ri";
import { LuClock4 } from "react-icons/lu";
import { HiUserGroup } from "react-icons/hi2";

import Button from "@/components/Button";
import CourseDetail from "./CourseDetail";
import CourseInfo from "../../components/Table/components/RowView";
// import { useParams } from "react-router-dom";
import { formatDateTime } from "../../../../utils/helpers";
import { Chip } from "@nextui-org/react";
import RowView from "../../components/Table/components/RowView";
import usePermission from "../../../../hooks/usePermission";

function CourseView({ course }) {
    const {
        brief,
        courseName,
        id,
        createdAt,
        updatedAt,
        visibility,
        videosDuration,
        studentsCount,
        lecturesCount,
    } = course;

    const { can } = usePermission();

    return (
        <>
            <CourseInfo
                title={courseName}
                brief={brief}
                maxName={10}
                maxBrief={30}
            />

            <RowView
                name={"تاريخ الانشاء"}
                brief={
                    <>
                        <span>
                            {" "}
                            الساعه : {formatDateTime(createdAt).formattedTime}
                        </span>
                        <span>
                            {" "}
                            يوم : {formatDateTime(createdAt).formattedDate}
                        </span>
                    </>
                }
                className={"flex"}
            />
            {createdAt !== updatedAt && (
                <RowView
                    name={"اخر تحديث"}
                    brief={
                        <>
                            <span>
                                {" "}
                                الساعه :{" "}
                                {formatDateTime(updatedAt).formattedTime}
                            </span>
                            <span>
                                {" "}
                                يوم : {formatDateTime(updatedAt).formattedDate}
                            </span>
                        </>
                    }
                    className={"flex"}
                />
            )}
            <RowView
                className={"flex"}
                name={"الحاله"}
                brief={
                    <Chip
                        className="gap-1 capitalize border-none text-default-600"
                        color={visibility ? "success" : "warning"}
                        size="md"
                        variant="dot"
                    >
                        {visibility == 1 ? "مفعل" : "غير مفعل"}
                    </Chip>
                }
            />

            {/* name and breif */}

            {/* courseDetail */}
            <div className="flex flex-wrap items-center justify-start px-3 py-2 bg-white rounded-xl gap-y-2">
                <CourseDetail
                    title={"الطلاب"}
                    icon={
                        <HiUserGroup className="text-md text-gray-color-primary" />
                    }
                    value={studentsCount}
                />
                <CourseDetail
                    title={"عدد المحاضرات"}
                    icon={
                        <RiBookMarkLine className="text-md text-gray-color-primary" />
                    }
                    value={lecturesCount}
                />
                <CourseDetail
                    title={"ساعات"}
                    icon={
                        <LuClock4 className="text-md text-gray-color-primary" />
                    }
                    value={videosDuration}
                />
            </div>
            {can("read:course:lectures") && (
                <div className="mt-3">
                    <Button
                        name="go to the course lectures page"
                        to={`${id}/lectures`}
                        type="primary"
                        className="w-full text-center"
                    >
                        الدخول
                    </Button>
                </div>
            )}
        </>
    );
}

export default CourseView;
